/**
 * Pagina recensioni: carica tutte le recensioni pubblicate Judge.me (scroll + Carica altre).
 */
(function () {
  if (window.__eldraHomeReviewsLoadAllBound) return;
  window.__eldraHomeReviewsLoadAllBound = true;

  var hostSelector = '.eldra-home-reviews--full #judgeme_all_reviews_page';
  var maxRounds = 40;

  function getHost() {
    return document.querySelector(hostSelector);
  }

  function reviewCount(host) {
    return host.querySelectorAll('.jdgm-all-reviews__body .jdgm-rev, .jdgm-rev').length;
  }

  function findLoadMore(host) {
    var nodes = host.querySelectorAll('a, button');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var text = (el.textContent || '').toLowerCase();
      if (
        text.indexOf('carica altre') !== -1 ||
        text.indexOf('load more') !== -1 ||
        el.classList.contains('jdgm-rev-widg__load-more')
      ) {
        return el;
      }
    }
    return null;
  }

  function nudgeScroll() {
    window.dispatchEvent(new Event('scroll'));
    var host = getHost();
    if (host) host.dispatchEvent(new Event('scroll'));
  }

  function pumpReviews() {
    var host = getHost();
    if (!host) return;

    var last = reviewCount(host);
    var stable = 0;
    var round = 0;

    function step() {
      if (round >= maxRounds) return;
      round += 1;

      var btn = findLoadMore(host);
      if (btn && btn.offsetParent !== null && !btn.disabled) {
        btn.click();
      }

      nudgeScroll();

      var now = reviewCount(host);
      if (now === last) stable += 1;
      else {
        stable = 0;
        last = now;
      }

      if (stable < 5) window.setTimeout(step, 700);
    }

    window.setTimeout(step, 500);
    window.setTimeout(step, 2000);
  }

  function setup() {
    var host = getHost();
    if (!host) return;

    if (typeof IntersectionObserver !== 'undefined') {
      var sentinel = host.querySelector('.eldra-reviews-load-sentinel');
      if (!sentinel) {
        sentinel = document.createElement('div');
        sentinel.className = 'eldra-reviews-load-sentinel';
        sentinel.setAttribute('aria-hidden', 'true');
        host.appendChild(sentinel);
      }

      new IntersectionObserver(
        function (entries) {
          if (entries[0] && entries[0].isIntersecting) pumpReviews();
        },
        { rootMargin: '400px 0px' }
      ).observe(sentinel);
    }

    pumpReviews();
  }

  document.addEventListener('DOMContentLoaded', setup);
  window.addEventListener('load', setup);
})();
